import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "inner-wrapper" };
const _hoisted_2 = { class: "brg-color-red-700" };
import { i18n } from '@/locales';
import { fulfillmentStatus } from '@/constants/operationSetting/operationSettingOptionList';
import { computed, nextTick, onMounted, ref, watch, } from 'vue';
import { delayTimeTypeOptionList, delayResonOptionList, stopResonOptionList, } from '@/constants/operationSetting/operationSettingSettingDialog';
import InputRow from '@/components/Form/InputRow.vue';
import { createOperationSettingFormRule } from '@/form/form-rules/operationSetting';
import { targetType } from '@/constants/operationSetting/option';
import vuexStore from '@/vuex-store';
const dialogLc = 'views.operation_setting_dialog.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryStatus',
    emits: ["setFormData"],
    setup(__props, { emit: __emit }) {
        // 운행설정 > 수행상황
        const locales = {
            applicableOrNot: i18n.t(`${dialogLc}applicable_or_not`),
            fulfillmentStateGood: i18n.t(`${dialogLc}fulfillment_state_good`),
            fulfillmentStateDelay: i18n.t(`${dialogLc}fulfillment_state_delay`),
            fulfillmentStateStop: i18n.t(`${dialogLc}fulfillment_state_stop`),
            deliveryDelayTime: i18n.t(`${dialogLc}delivery_delay_time`),
            deliveryDelayScope: i18n.t(`${dialogLc}delivery_delay_scope`),
            afterCurrentTimeInfo: i18n.t(`${dialogLc}after_current_time_info`),
            afterCurrentTime: i18n.t(`${dialogLc}after_current_time`),
            allDeliveryInfo: i18n.t(`${dialogLc}all_delivery_info`),
            allDeliveries: i18n.t(`${dialogLc}all_deliveries`),
            reasonForDelay: i18n.t(`${dialogLc}reason_for_delay`),
            reasonForStop: i18n.t(`${dialogLc}reason_for_stop`),
            delayTimePlaceholder: i18n.t('common.select_field_placeholder', {
                field: i18n.t(`${dialogLc}delivery_delay_time`),
            }),
            delayReasonPlaceholder: i18n.t('common.select_field_placeholder', {
                field: i18n.t(`${dialogLc}reason_for_delay`),
            }),
            stopReasonPlaceholder: i18n.t('common.select_field_placeholder', {
                field: i18n.t(`${dialogLc}reason_for_stop`),
            }),
        };
        const emit = __emit;
        const selectedTarget = computed(() => vuexStore.state.operationSetting.selectedTarget);
        const formRule = createOperationSettingFormRule();
        const setFormData = (key, value) => {
            nextTick(() => {
                emit('setFormData', key, value);
            });
        };
        // 원활 지연 중단
        const selectedStatus = ref(fulfillmentStatus.GOOD.value);
        watch(() => selectedStatus.value, (v) => {
            setFormData('deliveryStatusType', v);
        });
        const isTypeDelay = computed(() => selectedStatus.value === fulfillmentStatus.DELAY.value);
        const isTypeStop = computed(() => selectedStatus.value === fulfillmentStatus.STOP.value);
        // 지연 시간
        const delayTime = ref(null);
        watch(() => delayTime.value, (v) => {
            setFormData('delayTime', v);
        });
        const resetDelayTime = () => {
            delayTime.value = null;
        };
        watch(() => selectedStatus.value, () => {
            resetDelayTime();
        });
        // 지연 적용범위
        const isApplyAllOrder = ref(false);
        watch(() => isApplyAllOrder.value, (v) => {
            setFormData('isApplyAllOrders', v);
        });
        const resetIsApplyAllOrders = () => {
            isApplyAllOrder.value = false;
        };
        const applyAllOrderInfoText = computed(() => (isApplyAllOrder.value ? locales.allDeliveryInfo : locales.afterCurrentTimeInfo));
        watch(() => selectedStatus.value, () => {
            resetIsApplyAllOrders();
        });
        // 지연 사유 & 중단 사유
        const delayReason = ref(null);
        watch(() => delayReason.value, (v) => {
            setFormData('delayReason', v);
        });
        const resetDelayReason = () => {
            delayReason.value = null;
        };
        watch(() => selectedStatus.value, () => {
            resetDelayReason();
        });
        const init = () => {
            setFormData('deliveryStatusType', selectedStatus.value);
            setFormData('delayTime', delayTime.value);
            setFormData('delayReason', delayReason.value);
            setFormData('isApplyAllOrders', isApplyAllOrder.value);
        };
        onMounted(() => {
            init();
        });
        return (_ctx, _cache) => {
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_select = _resolveComponent("v-select");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 적용 여부 "),
                _createVNode(InputRow, {
                    label: locales.applicableOrNot,
                    "is-vertical-label": "",
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: selectedStatus.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedStatus).value = $event)),
                            inline: "",
                            dense: "",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                    label: locales.fulfillmentStateGood,
                                    value: _unref(fulfillmentStatus).GOOD.value
                                }, null, 8 /* PROPS */, ["label", "value"]),
                                _createVNode(_component_v_radio, {
                                    label: locales.fulfillmentStateDelay,
                                    value: _unref(fulfillmentStatus).DELAY.value
                                }, null, 8 /* PROPS */, ["label", "value"]),
                                _createVNode(_component_v_radio, {
                                    label: locales.fulfillmentStateStop,
                                    value: _unref(fulfillmentStatus).STOP.value
                                }, null, 8 /* PROPS */, ["label", "value"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _withDirectives(_createElementVNode("div", _hoisted_2, " * 선택한 허브가 관리하는 상점의 전체 설정이 변경됩니다. ", 512 /* NEED_PATCH */), [
                    [_vShow, selectedTarget.value === _unref(targetType).HUB]
                ]),
                _createCommentVNode(" 라디오버튼:: 운행(원활)은 별도 컨텐츠 존재하지 않음 "),
                _createCommentVNode(" 라디오버튼:: 운행(지연) "),
                (isTypeDelay.value)
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 0,
                        label: locales.deliveryDelayTime,
                        "is-vertical-label": "",
                        "is-required": ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_autocomplete, {
                                modelValue: delayTime.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((delayTime).value = $event)),
                                "item-title": "text",
                                "item-value": "value",
                                variant: "outlined",
                                density: "compact",
                                "bg-color": "white",
                                "hide-details": "auto",
                                rules: _unref(formRule).delayTime.value,
                                items: _unref(delayTimeTypeOptionList),
                                placeholder: locales.delayTimePlaceholder
                            }, null, 8 /* PROPS */, ["modelValue", "rules", "items", "placeholder"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 라디오버튼:: 운행(지연) "),
                (isTypeDelay.value)
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 1,
                        label: locales.deliveryDelayScope,
                        "is-vertical-label": "",
                        "is-required": "",
                        "show-info": "",
                        "info-text": applyAllOrderInfoText.value
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_radio_group, {
                                modelValue: isApplyAllOrder.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((isApplyAllOrder).value = $event)),
                                inline: "",
                                dense: "",
                                "hide-details": "auto"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_radio, {
                                        label: locales.afterCurrentTime,
                                        value: false
                                    }, null, 8 /* PROPS */, ["label"]),
                                    _createVNode(_component_v_radio, {
                                        label: locales.allDeliveries,
                                        value: true
                                    }, null, 8 /* PROPS */, ["label"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label", "info-text"]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 라디오버튼:: 운행(지연) "),
                (isTypeDelay.value)
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 2,
                        "is-required": "",
                        "is-vertical-label": "",
                        label: locales.reasonForDelay
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                                modelValue: delayReason.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((delayReason).value = $event)),
                                "item-title": "text",
                                "item-value": "value",
                                variant: "outlined",
                                density: "compact",
                                "bg-color": "white",
                                items: _unref(delayResonOptionList),
                                placeholder: locales.delayReasonPlaceholder,
                                rules: _unref(formRule).delayReason.value
                            }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder", "rules"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 라디오버튼:: 중단 "),
                (isTypeStop.value)
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 3,
                        "is-required": "",
                        "is-vertical-label": "",
                        label: locales.reasonForStop
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                                modelValue: delayReason.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((delayReason).value = $event)),
                                "item-title": "text",
                                "item-value": "value",
                                variant: "outlined",
                                density: "compact",
                                "bg-color": "white",
                                items: _unref(stopResonOptionList),
                                placeholder: locales.stopReasonPlaceholder,
                                rules: _unref(formRule).stopReason.value
                            }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder", "rules"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
